/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'fabric.editor.chromeCollapsedPlaceholder': 'Mit der Eingabe beginnen',
  'fabric.editor.editorAssistiveLabel': 'Hauptinhaltsbereich – geben Sie hier Ihren Text ein.',
  'fabric.editor.headingLink.toolbarHelpTitle': 'Hilfe öffnen',
};
